// Component: LogoGrid
// Author: Vijay Radhakrishnan
import * as React from 'react';
import LogoGridComponent from '@component/LogoGrid';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import EditableLink from '../../react/EditableLink';
import WBRString from '@component/WbrString';

export default function LogoGrid(props) {
  var levels = [];

  for (let i = 0; i < props.fields?.children?.length; i++) {
    let level = {};
    let item = props.fields.children[i];

    level.columnSize = item.fields?.ColumnSize?.fields?.Value?.value;
    level.levelText = item.fields?.LevelText?.value;

    let logos = [];

    for (let j = 0; j < item?.fields?.Logos?.length; j++) {
      let logo = {};

      logo.imageUrl = item.fields.Logos[j].fields?.Image?.value?.src;
      logo.imageAlt = item.fields.Logos[j].fields?.Image?.value?.alt;
      logo.linkUrl = item.fields.Logos[j].fields?.Link?.value?.url;
      logo.linkTarget = item.fields.Logos[j].fields?.Link?.value?.target;

      logos.push(logo);
    }

    level.logos = logos;
    levels.push(level);
  }

  var Sponsors = {
    linkUrl: props.fields.Link.value.href,
    linkText: props.fields.LinkText.value,
    linkTarget: props.fields.Link.value.target,
    levels: levels,
  };

  return (
    <>
      <LogoGridComponent {...Sponsors} />
    </>
  );
}
